/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Images
 */
import { PaintingIcon } from '../../../../../images/icons/AssetsIcons/Painting'
import { FurnitureIcon } from '../../../../../images/icons/AssetsIcons/Furniture'
import { SculpturesIcon } from '../../../../../images/icons/AssetsIcons/Sculptures'
import { JewelleryIcon } from '../../../../../images/icons/AssetsIcons/Jewellery'
import { RugsIcon } from '../../../../../images/icons/AssetsIcons/Rugs'
import { ObjetDartIcon } from '../../../../../images/icons/AssetsIcons/ObjetDart'
import { ClocksIcon } from '../../../../../images/icons/AssetsIcons/Clocks'
import { CollectiblesIcon } from '../../../../../images/icons/AssetsIcons/Collectibles'
import { BrittleIcon } from '../../../../../images/icons/AssetsIcons/Brittle'
import { symbol } from '../../../../common/CurrencyFormat'

/**
 *     Import
 *     - CSS
 */
import '../../styles/Step03.css'

const REGEXP = '^(?!(?:^[-+]?[0.]+(?:[Ee]|$)))(?!(?:^-))(?:(?:[+-]?)(?=[0123456789.])' +
    '(?:(?:(?:[0123456789]+)(?:(?:[.])(?:[0123456789]*))?|(?:(?:[.])(?:[0123456789]+))))' +
    '(?:(?:[Ee])(?:(?:[+-]?)(?:[0123456789]+))|))$'

/**
 * TableContent class
 *
 * @class TableContent
 * @extends {React.Component<any, any>}
 */
class TableContent extends React.Component<any, any> {

    /**
     * Creates an instance of TableContent.
     *
     * @param {*} props
     * @memberof TableContent
     */
    constructor(props: any) {
        super(props)

        this.state = {
            tableItems: props.tableItems,
            settlementBasis: props.settlementBasis,
            updateParentStateItems: props.updateParentStateItems,
        }

    }

    /**
     * If there are new props from the father,
     * would update its current state with the new data
     *
     * @param {*} nextProps
     * @memberof TableContent
     */
    componentWillReceiveProps(nextProps: any) {
        this.setState({
            tableItems: nextProps.tableItems,
            settlementBasis: nextProps.settlementBasis,
        })
    }

    /**
     * It creates all the elements to show in the table
     *
     * @memberof TableContent
     */
    _createTableContent = () => {
        return this.state.tableItems.map((item) => {
            return (
                <div className="table__content" key={item.type}>
                    <div className="table__50-item">
                        <div className="table__50-item--row15">
                            {this._getMatchingIcon(item.type)}
                        </div>
                        <div className="table__50-item--row85">
                            {item.text}
                        </div>
                    </div>
                    <div className="table__30-item">
                        <div className="input">
                            <div className="input__pound">
                                {symbol()}
                            </div>
                            <input
                                type="number"
                                name={item.type}
                                onChange={(event) => { this._calculateValue(event, item) }}
                                value={item.valueStock}
                                placeholder="0"
                                step="any"
                                min="0"
                                pattern={REGEXP}
                            />
                        </div>
                    </div>
                    <h4 className="table__20-item"> {`${symbol()} ${item.valueInsured}`}</h4>
                </div>
            )
        })
    }

    /**
     * Generates the corresponding Icon ot the item
     * passed as parameter
     *
     * @param {String} item the item to show
     * @memberof TableContent
     */
    _getMatchingIcon = (item: String) => {
        switch (item) {
            case 'picturesPainingsPrints':
                return <PaintingIcon />

            case 'antiquesFurniture':
                return <FurnitureIcon />

            case 'bronzesSculpturesMarbles':
                return <SculpturesIcon />

            case 'antiqueJewellery':
                return <JewelleryIcon />

            case 'carpetsRugsTapestriesTextiles':
                return <RugsIcon />

            case 'silverObjectDArt':
                return <ObjetDartIcon />

            case 'clocks':
                return <ClocksIcon />

            case 'collectiblesMemorabilia':
                return <CollectiblesIcon />

            case 'porcelainBrittleItems':
                return <BrittleIcon />

            default:
                return ''
        }
    }

    /**
     * Calculates the corresponding Selling/Cost and sum insured columns
     *
     * @param {*} event the event to trigger
     * @param {*} item the item to update
     * @memberof TableContent
     */
    _calculateValue = (event, item) => {
        if (event.target.value !== '') {
            item.valueStock = event.target.value.replace(/^-*/, '').replace(/^0+/, '')
            if (item.valueStock === '') {
                item.valueStock = '0'
            }
            item.valueInsured = (parseFloat(item.valueStock) * this.state.settlementBasis).toFixed(2)
            this._updateStateItem(item)
        } else {
            item.valueStock = '0'
            item.valueInsured = Number(0)
            this._updateStateItem(item)
        }
    }

    /**
     * Updates a new item from the tableItems
     * in the state of the component
     *
     * @param {*} itemToUpdate
     * @memberof TableContent
     */
    _updateStateItem(itemToUpdate: any) {
        let provItems = this.state.tableItems
        this.state.tableItems.map((item, index) => {
            if (this.state.tableItems[index].type === itemToUpdate.type) {
                provItems[index] = itemToUpdate
            }
        })

        this.state.updateParentStateItems(provItems)
        this.setState({ tableItems: provItems })
    }

    render() {
        return (
            <div>
                {this._createTableContent()}
            </div>
        )
    }
}

export default TableContent



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step03/components/TableContent.tsx